import { ACTIVITY } from "../constants";
import { instance } from "../../axios";

// filters: from, to (YYYY-MM-DD), local (id or "none"), weekday (1-7),
// hourFrom, hourTo, all in the shop's time and optional
const getActivitiesAction = (limit, offset, action = null, companyId = null, filters = {}) => {
  return (dispatch) => {
    dispatch({
      type: ACTIVITY.GET_ACTIVITIES,
    });
    const params = new URLSearchParams({ limit, offset });
    if (action) params.append("action", action);
    if (companyId) params.append("company_id", companyId);
    ["from", "to", "local", "weekday", "hourFrom", "hourTo"].forEach((key) => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') params.append(key, filters[key]);
    });
    instance
      .get(`/activity?${params.toString()}`)
      .then((results) => {
        dispatch({
          type: ACTIVITY.GET_ACTIVITIES_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: ACTIVITY.GET_ACTIVITIES_FAILURE,
          payload: error,
        });
      });
  };
};

const deleteActivityAction = (id) => {
  return (dispatch) => {
    dispatch({
      type: ACTIVITY.DELETE_ACTIVITY,
    });
    return instance
      .delete(`/activity/${id}`)
      .then(() => {
        dispatch({
          type: ACTIVITY.DELETE_ACTIVITY_SUCCESS,
          payload: id,
        });
      })
      .catch((error) => {
        dispatch({
          type: ACTIVITY.DELETE_ACTIVITY_FAILURE,
          payload: error,
        });
        throw error;
      });
  };
};

export { getActivitiesAction, deleteActivityAction };
